/**
 * Created by Maga on 31.05.2018.
 */
export enum ModuleENUM {
  ADMIN = 'ROLE_ADMIN',
  MODERATOR = 'ROLE_MODERATOR',
  ADMIN_REGION = 'ROLE_ADMIN_REGION',
  ENROLL = 'ROLE_ENROLL',                                     // Роль для пользователя - абитуриента, не путать с модулем "Абитуриент" (он ниже ↓ )
  LOCAL_ROLE_EDIT = 'LOCAL_ROLE_EDIT',
  REPORTS = 'REPORTS',
  USERS = 'USERS',                                            // Пользователи
  DATA_TUTORS = 'TUTORS',                                     // ППС колледжей
  DATA_REPLICATIONS = 'REPLICATIONS',                         // Результаты выполненных репликаций БД
  DATA_GRADUATES = 'GRADUATES',                               // Выпускники
  DATA_STUDENTS = 'STUDENTS',                                 // Обучающиеся
  GPRON = 'SEDP',                                             // Реализация ГПРОН
  GRANTS = 'GRANTS',                                          // Планирование финансирования в рамках ГОЗ
  FORM_APPLICATION = 'FORM_APPLICATION',                      // Заявки на выдачу бланков
  FORM_APPLICATION_PROCESS = 'FORM_APPLICATION_PROCESS',      // Обработка заявок на выдачу бланков
  DICTIONARY = 'DICTIONARY',                                  // Справочники
  MESSAGES = 'MESSAGES',                                      // Письма
  PUBLIC_SERVICES = 'PUBLIC_SERVICES',                        // Госуслуги
  REGISTER_GRADUATES_PROCESS = 'REGISTER_GRADUATES_PROCESS',  // Обработка заявлений выпускников
  REPORT_EDITOR = 'REPORT_EDITOR',                            // Редактор отчетов
  REP_SUBMISSIONS = 'REP_SUBMISSIONS',                        // Подача заявлений в Реестр образовательных программ
  USER_APPLICATIONS = 'USER_APPLICATIONS',                    // Обработка заявок на регистрацию в системе
  ENROLLE  = 'REQUEST_ENROLL',                                // Абитуриенты,
  DATA_COLLEGE_INFO = 'COLLEGE_INFO',                         // Данные по образовательным учреждениям,
  DATA_APPLICANTS = 'APPLICANTS',                             // Абитуриенты,
  DORMITORY_INFO = 'DORMITORY_INFO',                          // общежитие,
  PLATONUS_RELEASE = 'PLATONUS_RELEASE',                      // Обновления системы Platonus
  GOV_SERVICES = 'PUBLIC_SERVICES',                           // Модуль "Государственные услуги"
  COLLEGE_CAPACITY = 'COLLEGE_CAPACITY',                      // Модуль "Проектная мощность образовательных учреждений"
}



// WEBPACK FOOTER //
// ./src/app/common/enums/module.enum.ts